module.exports = __webpack_public_path__ + "media/images/recipes/twentse_bakleverworst-4a86e7ac93e15cf961da283b8834ee05.pdf";